import HOCWatchValue from 'components/common/hoc-watch-value';
import TableEditableComponent from 'components/elements/table/table';
import { ColumnDataType } from 'components/elements/table/type';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

export default function AirlineTable(props: { parentIdx: number }) {
  const { t } = useTranslation();
  const name: any = `approvalable.tourFlights.${props.parentIdx}.tourFlightAirlines`;
  const value = HOCWatchValue({ keys: [name] });

  const columns = [
    {
      header: t('common:airline'),
      accessorKey: 'airlineName',
      minSize: 100,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:date'),
      accessorKey: 'date',
      minSize: 100,
      dataType: ColumnDataType.date,
    },
    {
      header: t('common:detail'),
      accessorKey: 'detail',
      minSize: 100,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:class'),
      accessorKey: 'preferenceName',
      minSize: 100,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:route'),
      accessorKey: 'route',
      minSize: 100,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:time'),
      accessorKey: 'time',
      minSize: 100,
      dataType: ColumnDataType.text,
    },
  ];

  return (
    <div style={{ width: '100' }}>
      <TableEditableComponent
        columns={columns}
        data={value[name]}
        dispatch={() => {}}
        disabled
        name={name}
      />
    </div>
  );
}
